<template>
  <div>
    <div class="clearfix">
      <h3 class="text-bold col-sm-4">Create Employee</h3>
      <router-link
        :to="{ path: '/performance_scanning/employees/list' }"
        class="btn btn-info pull-right"
      >
        Back
      </router-link>
    </div>

    <div class="alert alert-danger mt-20" v-if="Object.keys(errors).length">
      <h4 class="semi-bold text-danger">
        <span class="fa fa-exclamation-triangle"></span> Sorry, there were some
        errors!
      </h4>
      <p class="text-danger">
        Please check the form, correct the issues and try again.
      </p>
    </div>

    <div class="grid shadow bg-white mt-20">
      <div class="grid-title">
        <h4 class="heading semi-bold">Create an Employee</h4>
      </div>
      <div class="grid-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Name</label>
              <div class="col-sm-5">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.first_name"
                  placeholder="First Name"
                />
                <small v-if="errors.first_name" class="form-text text-danger">
                  {{ errors.first_name.join(" ") }}
                </small>
              </div>
              <div class="col-sm-5">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.last_name"
                  placeholder="Last Name"
                />
                <small v-if="errors.last_name" class="form-text text-danger">
                  {{ errors.last_name.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Nickname</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.nickname"
                  placeholder="Nickname"
                />
                <small v-if="errors.nickname" class="form-text text-danger">
                  {{ errors.nickname.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Department</label>
              <div class="col-sm-10">
                <v-select
                  placeholder="Choose One"
                  @input="setDepartmentSelected"
                  v-model="employee.department"
                  :options="pageData.departments"
                />
                <small v-if="errors.department" class="form-text text-danger">
                  {{ errors.department.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Position</label>
              <div class="col-sm-10">
                <v-select
                  placeholder="Choose One"
                  v-model="employee.position_id"
                  label="name"
                  :reduce="(position) => position.id"
                  :options="pageData.positions_filtered"
                />
                <small v-if="errors.position" class="form-text text-danger">
                  {{ errors.position_id.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Start / End Dates</label>
              <div class="col-sm-5">
                <input
                  type="date"
                  class="form-control"
                  v-model="employee.befeni_start"
                  placeholder="Start Date"
                />
                <small v-if="errors.befeni_start" class="form-text text-danger">
                  {{ errors.befeni_start.join(" ") }}
                </small>
              </div>
              <div class="col-sm-5">
                <input
                  type="date"
                  class="form-control"
                  v-model="employee.befeni_end"
                  placeholder="End Date"
                />
                <small v-if="errors.befeni_end" class="form-text text-danger">
                  {{ errors.befeni_end.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Birth City</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.birth_city"
                  placeholder="Birth City"
                />
                <small v-if="errors.birth_city" class="form-text text-danger">
                  {{ errors.birth_city.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Marital Status</label>
              <div class="col-sm-10">
                <v-select
                  placeholder="Choose One"
                  v-model="employee.marital_status"
                  :options="pageData.marital_status"
                />
                <small
                  v-if="errors.marital_status"
                  class="form-text text-danger"
                >
                  {{ errors.marital_status.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">children</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.children"
                  placeholder="Children"
                />
                <small v-if="errors.children" class="form-text text-danger">
                  {{ errors.children.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Hobby #1</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.hobby1"
                  placeholder="Hobby #1"
                />
                <small v-if="errors.hobby1" class="form-text text-danger">
                  {{ errors.hobby1.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Hobby #2</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.hobby2"
                  placeholder="Hobby #2"
                />
                <small v-if="errors.hobby2" class="form-text text-danger">
                  {{ errors.hobby2.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Favorite Food</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.favorite_food"
                  placeholder="Favorite Food"
                />
                <small
                  v-if="errors.favorite_food"
                  class="form-text text-danger"
                >
                  {{ errors.favorite_food.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Favorite Fabric</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.favorite_fabric"
                  placeholder="Favorite Fabric"
                />
                <small
                  v-if="errors.favorite_fabric"
                  class="form-text text-danger"
                >
                  {{ errors.favorite_fabric.join(" ") }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button
      class="btn-primary btn-large btn btn-block"
      @click="createEmployee()"
    >
      Create Employee
    </button>
  </div>
</template>
<script>
import vSelect from "vue-select";
import vueCountryRegionSelect from "vue-country-region-select";

export default {
  components: {
    vSelect,
    vueCountryRegionSelect,
  },
  data() {
    return {
      errors: {},
      pageData: {
        departments: [],
        positions: [],
        positions_filtered: [],
        marital_status: [],
      },
      employee: {
        first_name: null,
        last_name: null,
        nickname: null,
        department: null,
        position_id: null,
        befeni_start: null,
        befeni_end: null,
        birth_city: null,
        marital_status: null,
        children: null,
        hobby1: null,
        hobby2: null,
        favorite_food: null,
        favorite_fabric: null,
      },
    };
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    async getPageData() {
      try {
        let results = await axios({
          method: "get",
          url: "/v2/performance_scanning/employees/create",
        });
        this.pageData = results.data.data;
        this.pageData.positions_filtered = this.pageData.positions;
      } catch (error) {
        alert("Unable to load page data, contact the admins");
      }
    },

    setDepartmentSelected(selectedDepartment) {
      this.pageData.positions_filtered = this.pageData.positions.filter(
        (position) => position.department == selectedDepartment
      );
    },

    async createEmployee() {
      try {
        this.errors = {};
        let results = await axios({
          method: "post",
          url: "/v2/performance_scanning/employees",
          data: this.employee,
        });
        this.$router.push("/performance_scanning/employees/list");
      } catch (error) {
        this.errors = error.response.data.errors;
        window.scrollTo(0, 0);
      }
    },
  },
};
</script>

<style scoped>
@import "~sweetalert2/dist/sweetalert2.min.css";
@import "~vue-select/dist/vue-select.css";

.col-form-label {
  margin-top: 10px;
}

.btn-info {
  margin-top: 15px;
}
</style>
